import styled from 'styled-components';
import React from 'react';
import { SvgIcon } from '../../Icon';
import { theme } from '../../../styles/theme';

const DragOverlayWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  column-gap: 4px;

  border: 1px solid ${theme.colors.border};

  background-color: ${theme.colors.tableHeader};
  color: ${theme.colors.secondary800};
  font-size: 12px;
  font-weight: 600;

  padding: 8px 7px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  cursor: pointer;
  user-select: none;

  opacity: 0.7;
  width: 120px;
`;

interface IProps {
  header: string | null;
}

const ChartHeaderDragOverlay = ({ header }: IProps) => {
  return (
    <DragOverlayWrapper>
      <>
        <SvgIcon
          name="drag-drop"
          width={8}
          height={8}
          customFill="currentColor"
        />
        {header}
      </>
    </DragOverlayWrapper>
  );
};

export default ChartHeaderDragOverlay;
